export const environment = {
  apiUrl: 'https://api.testrequisitionforms.idexx.com/',
};
